import { render, staticRenderFns } from "./InsurancePlans.vue?vue&type=template&id=47b2fd37"
import script from "./InsurancePlans.vue?vue&type=script&lang=js"
export * from "./InsurancePlans.vue?vue&type=script&lang=js"
import style0 from "./InsurancePlans.vue?vue&type=style&index=0&id=47b2fd37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports